<template>
    <!-- <v-container>
        <v-row dense v-if="mode=='title'">      
            <Title ref="title" @onClickTitleMenuButton="onClickTitleMenuButton" />
        </v-row>    
        <v-row dense v-if="mode=='setting'">
            <Setting />
        </v-row>    
        <v-row dense v-if="mode=='field'">
          <FieldWork />
        </v-row>
        <v-row dense v-if="mode=='group'">
            <GroupManager @onSelectedGroupUser="onSelectedGroupUser" />
        </v-row>
        <v-row dense v-if="mode=='notification_manage'">
            <NotificationManager />
        </v-row>
        <v-row dense v-if="mode=='test'">
            <Seedling />
        </v-row>
        <Confirm ref="confirm" />
        <v-snackbar v-model="notification.isView" :timeout=2000 :color="notification.color" vertical>{{notification.message}}</v-snackbar>
    </v-container> -->
    <div>
        <InitialSetting ref="initialSetting" @onCompletedInitialSetting="onCompletedInitialSetting" />
        <v-expand-transition>
            <Title v-if="mode=='title'" ref="title" @onClickTitleMenuButton="onClickTitleMenuButton" />
            <TodayWorks v-else-if="mode=='today_works'" />
            <Setting v-else-if="mode=='setting'" />
            <GroupManager v-else-if="mode=='group'" @onSelectedGroupUser="onSelectedGroupUser" />
            <NotificationManager v-else-if="mode=='notification_manage'" />
            <Seedling v-else-if="mode=='seedling'" />
            <Place v-else-if="mode=='place'" />
            <Box v-else-if="mode=='box'" />
            <Observate v-else-if="mode=='observate_item'" />
            <Camera v-else-if="mode=='camera'" />
            <SystemMaintenanceViewer v-else-if="mode=='maintenance'" :systemState="systemState" />
            <Knowledge v-else-if="mode=='knowledge'" />
            <Logout v-else-if="mode=='logout'" />
            <Login v-else :loggedInListener="loggedInListener" />
        </v-expand-transition>
        <Confirm ref="confirm" />
        <Version ref="version" />
        <v-snackbar v-model="notification.isView" :timeout=2000 :color="notification.color" vertical multi-line>{{notification.message}}</v-snackbar>
    </div>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import InitialSetting from '@/components/InitialSetting';
    import Title from '@/components/title/Title';
    import TodayWorks from '@/components/today_works/TodayWorks';
    import Setting from '@/components/setting/Setting';
    import GroupManager from '@/components/group/GroupManager';
    import NotificationManager from '@/components/notification/NotificationManager';
    import Seedling from '@/components/seedling/SeedlingManager';
    import Place from '@/components/place/PlaceManager';
    import Box from '@/components/box/BoxManager';
    import Observate from '@/components/observate_item/ObservateItemManager';
    import Camera from '@/components/camera/Camera';
    import SystemMaintenanceViewer from '@/components/SystemMaintenanceViewer';
    import UnknownStateViewer from '@/components/UnknownStateViewer';
    import Login from '@/components/Login';
    import Logout from '@/components/Logout';
    import Confirm from '@/components/tools/ConfirmDialog';
    import Version from '@/components/VersionViewer';
    import Knowledge from '@/components/knowledge/KnowledgeBankManager';
    import db from '@/firebase/firestore.js'
    import fb from '@/firebase/firebase.js'
    import Axios from "axios"

    export default {
        name: 'MainController',
        components: {
            InitialSetting,
            Title,
            TodayWorks,
            Setting,
            GroupManager,
            NotificationManager,
            Seedling,
            Place,
            Box,
            Observate,
            Camera,
            SystemMaintenanceViewer,
            UnknownStateViewer,
            Login,
            Logout,
            Confirm,
            Version,
            Knowledge
        },
        data: () => ({
            lastNotificationDateTime: "",
            isShowNotification: false,
            systemState: null
        }),
        computed: {
            loggedInUserData: function () {
                return this.$store.getters["loggedInUserData"]
            },
            requestBackToHome: function () {
                return this.$store.getters["requestBackToHome"]
            },
            loginState: function () {
                return this.$store.getters["loginState"]
            },
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            notification: function () {
                return this.$store.getters["notification"]
            },
            selectedMenuItem: function () {
                return this.$store.getters["selectedMenuItem"]
            },
            /**
             * 送受信した通知
             */
            notifications: function () {
                return this.$store.getters["managementItems/notifications"]
            },
            /**
             * Homeの表示モード
             */
            mode: {
                get: function () {
                    return this.$store.getters["homeMode"]
                },
                set: function (value) {
                    this.$store.commit("homeMode", value)
                }
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /**
             * 共有中に参照しているユーザーが所属しているグループでの自分のユーザーデータ
             */
            shareUserGroupMyUserData: function () {
                return this.$store.getters["managementItems/shareUserGroupMyUserData"]
            },
            /**
             * ログイン中のユーザーの圃場データ、共有中であればグループユーザーの圃場データ
             */
            placeData: function () {
                if (!this.isShareMode) {
                    return this.$store.getters["managementItems/loggedInUserPlaceData"]
                } else {
                    return this.$store.getters["managementItems/groupUserPlaceData"]
                }
            },
            /**
             * 圃場データの初期化中か否か
             */
            isPlaceDataInitializing: function () {
                const data = this.placeData
                for (var i=0; i<data.places.length; i++) {
                    if (data.places[i].works == null) {
                        console.log("works is null")
                        return true
                    }
                    if (data.places[i].workTypes == null) {
                        console.log("workTypes is null")
                        return true
                    }
                    if (data.places[i].userWorkTypes == null) {
                        console.log("userWorkTypes is null")
                        return true
                    }
                }
                return false
            }
        },
        watch: {
            isPlaceDataInitializing: function (value, old) {
                console.log("======== isPlaceDataInitializing =============", value)
                if (value) {
                    this.$store.commit("processing", {start:true, message:"圃場データを読み取っています…。電源を切らないで下さい。"})
                } else {
                    this.$store.commit("processing", {start:false})
                }
            },
            selectedMenuItem: function (value, oldValue) {
                // console.log("selectedMenuItem", value, oldValue)
                this.onClickTitleMenuButton(value)
            },
            requestBackToHome: function (value) {
                if (value == true) {
                    try{
                        if (this.systemState.state != 1) {
                            return
                        }
                        this.$store.commit("requestBackToHome", false)
                        this.$store.commit("selectedMenuItem", null)
                        this.mode = "title"
                    } catch (error) {
                        console.log(error)
                    }
                }
            },
            // loginState: function (value, old) {
            //     console.log("loginState changed!!", value, old)
            //     const self = this
            //     if (value == 1) {
            //     }
            //     if (value == 2) {
            //         // ログアウト時
            //         this.mode = "title"
            //         this.login()
            //     }
            // },
            loggedInUserData: function (value, old) {
                console.log("Home", "(watch)loggedInUserData", value, old)
                const self = this

                if (value != null) {

                    db.collection("system").doc("system_state").get().then(function(doc){

                        self.systemState = doc.data()

                        if (self.systemState.currentVersion > self.$store.getters["systemVersion"]) {
                            self.$refs.confirm.show({
                                title: "アップデート",
                                message: "圃場管理システムのアップデートがあります。<br/>Version:"+self.systemState.currentVersion+"<br/>OK を押すと、ログアウトしてシステムをアップデートします。",
                                width: 500,
                                buttonYes: "OK",
                                buttonNo: "",
                                listenerYes: function () {
                                    self.logout()
                                    return true
                                },
                            })
                        } else {
                            switch (self.systemState.state) {
                                case 1:
                                    // システム運用中
                                    /** "送受信した通知の管理" を開始 */
                                    self.$store.commit("managementItems/startManagementNotifications")
                                    /** "グループ及び所属グループの管理" を開始 */
                                    self.$store.commit("managementItems/startManagementGroups")
                                    /** "農薬関連データの管理" を開始 */
                                    self.$store.commit("managementItems/startManagementAgrichemical")
                                    /** "システムの作業種類データの管理" を開始 */
                                    self.$store.commit("managementItems/startManagementSystemWorkTypes")
                                    /** "圃場データの管理" を開始 */
                                    self.$store.commit("managementItems/startManagementLoggedInUserPlaceData")

                                    // Welcomeメッセージをユーザーの通知にコピー
                                    const userData = self.loggedInUserData
                                    if (userData.systemNotification.lastDateTime == "") {
                                        db.collection("system_notifications").doc("20201001171336").get().then(function(doc){
                                            const notification = doc.data()
                                            db.collection("users").doc(userData.userUID)
                                            .collection("notifications").doc(notification.notificationID)
                                            .set(notification).then(function(){
                                                // ユーザー情報の最後に取得したシステム通知の日時を引数で取得した日時に設定
                                                userData.systemNotification.lastDateTime = self.df_currentDateTime()
                                                db.collection("users").doc(userData.userUID).update(
                                                    {"systemNotification.lastDateTime": userData.systemNotification.lastDateTime}
                                                )
                                            })
                                        })
                                    }
                                    break;
                                case 10:
                                    // システムメンテナンス
                                    self.mode = "maintenance"
                                    break
                            }
                        }
                    }).catch (function (error){
                        self.$refs.confirm.show({
                            title: "ログインエラー",
                            message: "ログインに失敗しました。<br/>" + error,
                            width: 500,
                            buttonYes: "OK",
                            buttonNo: "",
                            listenerYes: function () {
                                self.logout()
                                return true
                            },
                        })
                    })
                }
            },
            /**
             * 送受信した通知が更新された時
             */
            notifications: {
                handler: function (value, old) {
                    // console.log("notifications changed", "送信通知件数="+value.sendList.list.length, "受信通知件数="+value.receiveList.list.length)
                    const self = this
                    value.receiveList.list.forEach(function(notification) {
                        // console.log(notification.body.openedDateTime, notification.body.dateTime, self.lastNotificationDateTime)
                        if (notification.body.openedDateTime == "" && (self.lastNotificationDateTime == "" || notification.body.dateTime > self.lastNotificationDateTime)) {
                            // 未開封の通知で、かつ最後に通知表示した通知の受信日時以降であれば通知表示
                            self.lastNotificationDateTime = notification.body.dateTime
                            self.$store.commit(
                                "notification", 
                                {
                                    message: "新しい通知 >> " + notification.body.content.title, 
                                    isError: false
                                }
                            )
                        }
                    })
                },
                deep: true
            }
        },
        created: function () {
            console.log("Home", "created")
                
            const self = this

            /** 戻るボタンの制御 */
            window.addEventListener("popstate", function (e) {
            
                if (self.mode != "title" && self.mode != null) {
                    self.$store.commit("requestBackToHome", true)
                    history.pushState(null, null, null);
                }
                return;

            });

            this.$store.commit("shareMode", this.shareModeTypes.myWork)
            this.$store.commit("sharedUser", null)
            this.login()
        },
        mounted: function () {
        },
        methods: {
            /**
             * ログアウト処理
             */
            logout: function () {
                const self = this
                self.$store.commit("homeMode", "logout")
                self.mi_writeLog("App/logout", "logout")

                setTimeout(
                    function() {
                        fb.auth().signOut().then(function (){
                            console.log("firebase logout success")
                            self.$store.commit("userUID", "")
                            self.$store.commit("userData", null)
                            self.$store.commit("loginState", 2)
                            self.$store.commit("selectedMenuItem", "")
                            console.log("state cleared")
                            setTimeout(
                                function () {
                                    if (navigator.serviceWorker != null && navigator.serviceWorker.getRegistrations != null) {
                                        console.log("service worker delete start")
                                        navigator.serviceWorker.getRegistrations().then(function(registrations){
                                            try {
                                                for (const registration of registrations) {
                                                    registration.unregister()
                                                    console.log("service worker unregist!")
                                                }
                                            } catch (error) {
                                                console.log("service worker unregist failed!! => " + error)
                                            }
                                            console.log("page reload start")
                                            window.location.reload(true)
                                        })
                                    } else {
                                        console.log("page reload start")
                                        window.location.reload(true)
                                    }
                                },
                                1000
                            )
                        }).catch (function(error) {
                            console.log("logout failed!! reload start")
                            window.location.reload(true)
                        })
                    },
                    1000
                )
            },
            // stopNotificationWatch: function () {
            //     console.log("notifications watch end")
            // },
            // onClickRestart: function () {
            //     console.log(this)
            //     window.location.reload()
            // },
            /**
             * 初期設定終了時
             */
            onCompletedInitialSetting: function () {
                // console.log("Home", "onCompletedInitialSetting")
                const self = this
                this.mode = null
                setTimeout(
                    function() {
                        self.mode = "title"
                    },
                    100
                )
            },
            /**
             * メニューボタン押下時
             */
            onClickTitleMenuButton: function (name) {

                this.mi_writeLog("Home/onClickTitleMenuButton", name)

                // スクロールを先頭に戻す
                window.scrollTo(0, 0)

                switch (name) {
                    case "group":
                        this.mode = 'group'
                        break;
                    case "setting":
                        this.mode = 'setting'
                        break;
                    case "notification":
                        this.mode = 'notification_manage'
                        break;
                    case "seedling":
                        this.mode = 'seedling'
                        break;
                    case "place":
                        this.mode = 'place'
                        break;
                    case "box":
                        this.mode = 'box'
                        break;
                    case "camera":
                        this.mode = 'camera'
                        break;
                    case "knowledge":
                        this.mode = 'knowledge'
                        break;
                    case "today_works":
                        this.mode = 'today_works'
                        break;
                    case "memo":
                        this.$refs.confirm.show({
                            title: "メモ",
                            message: "メモ機能は現在実装されておりません。",
                            width: 500,
                            buttonYes: "戻る",
                            buttonNo: "",
                        })                        
                        break;
                    case "endShare":
                        this.$store.commit("sharedUser", null)
                        this.$store.commit("shareMode", this.shareModeTypes.myWork)
                        break;
                    case "version":
                        this.$refs.version.show()
                        this.$store.commit("selectedMenuItem", null)
                        break
                }
            },
            /**
             * グループ管理画面において、グループユーザーの圃場管理が選択された時
             * ここで共有処理を開始する。
             */
            onSelectedGroupUser: async function (params) {
                // console.log("Home", "onSelectedGroupUser", params)
                this.$store.commit("shareMode", this.shareModeTypes.groupUserWork)
                this.$store.commit("sharedUser", 
                {
                    group: params.group,
                    user: params.user
                })
                const referenceUserInfo = {
                    group: {
                        ownerUserUID: params.user.body.ownerUserUID,
                        groupNo: params.user.body.groupNo
                    },
                    userUID: params.user.body.userUID
                }
                // console.log("Home", "onSelectedGroupUser", referenceUserInfo)
                const userUID = this.$store.getters["loggedInUserUID"]
                await db.collection("users").doc(userUID).update(
                    {
                        "referenceUserInfo": referenceUserInfo
                    }
                )
                this.$store.commit("managementItems/setShareUserGroupMyUserData", {
                    ownerUserUID: params.group.body.ownerUserUID,
                    groupNo: params.group.body.groupNo
                })
                /** "圃場データの管理" を開始 */
                this.$store.commit(
                    "managementItems/startManagementGroupUserPlaceData", 
                    {
                        userUID: params.user.body.userUID,
                    }                    
                )
                this.mode = "title"
                // const self = this
                // const currentDateTime = this.df_currentDateTime()
                // db.collection("users").doc(params.userUID).collection("temporary_users").doc(this.$store.getters["userUID"]).set(
                //     {
                //         mode: "group access",
                //         dateTime: currentDateTime
                //     }).then(function(){
                //         console.log("Home", "temporary_user_created")
                //         self.$store.commit("shareMode", self.shareModeTypes.groupUserWork)
                //         self.$store.commit("sharedUser", params)
                //         self.mode = "seedling"
                //     }).catch(function(error){
                //         console.log(error)
                //     })
            },
            /**
             * firebaseログイン後の処理
             */
            loggedInListener: function (user) {
                
                const self = this

                history.pushState(null, null, null);

                self.$store.commit("firebaseUser", user)
                self.$store.commit("loginState", 1)
                self.$store.commit("userUID", user.uid)
                self.$store.commit("refreshArea")

                // self.$store.commit("refreshRegisteredFields")
                self.$store.commit("refreshUserData", 
                    {
                        userUID: user.uid,
                        completed: function () {
                            try {
                                // const url = 'https://service.tomson.xyz/ipinfo'
                                // Axios.get(url).then(function(res){
                                //     console.log(res)
                                //     const dateTime = self.df_currentDateTime()
                                //     db.collection("users").doc(user.uid).collection("login_histories").doc(dateTime).set(
                                //         {
                                //             dateTime: dateTime,
                                //             ip: res.data.ip
                                //         }
                                //     )
                                // }).catch (function(error){
                                //     console.log(error)
                                // })
                                self.mi_writeLog("Home/loggedInListener", "login(Version."+self.$store.getters["systemVersion"]+")")
                                // const url = 'https://service.tomson.xyz/myfield_services/logger'
                                // Axios.get(url, {params: {userUID: user.uid, message:"login"}}).then(function(res){
                                //     console.log(res)
                                // }).catch (function(error){
                                //     console.log(error)
                                // })
                            } catch (error) {
                                console.log("Home", "loggedInListener", "error", error)
                            }

                            var userData = self.$store.getters["userData"]
                            // console.log("Home", "login", "userData", userData, "firebase user", self.$store.getters["firebaseUser"])
                            if (userData == null || userData.userUID == undefined) {
                                // console.log("Home", "created", "user data not regist!")
                                self.$refs.confirm.show({
                                    title: "ようこそ",
                                    message: "圃場管理システムへようこそ。<br/>まずは、初期設定を行いましょう。",
                                    width: 500,
                                    buttonYes: "開始",
                                    buttonNo: "",
                                    listenerYes: function () {
                                        self.$refs.initialSetting.show(user.uid)
                                        // self.onClickTitleMenuButton("setting")
                                        return true
                                    },
                                })
                                self.mode = null
                            } else {
                                // console.log("Home", "created", "user data refresh!", self.$store.getters["userData"])
                                self.mode = "title"
                                try {
                                    const systemVersion = self.$store.getters["systemVersion"]
                                    if (userData.systemVersion != null) {
                                        userData.systemVersion = systemVersion
                                        db.collection("users").doc(userData.userUID).update(
                                            {
                                                "systemVersion": userData.systemVersion
                                            }
                                        ).then(function(){
                                            console.log("user data version set success!!(update)")
                                        }).catch (function(error) {
                                            console.log("user data version set failed!!(update)", error)
                                        })
                                    } else {
                                        userData.systemVersion = systemVersion
                                        db.collection("users").doc(userData.userUID).set(userData).then(function(){
                                            console.log("user data version set success!!(set)")
                                        }).catch (function(error) {
                                            console.log("user data version set failed!!(set)", error)
                                        })
                                    }
                                } catch (error) {
                                    console.log("user data version set failed!!", error)
                                }
                            }
                        },
                        failed: function (error) {
                            // console.log(error)
                            self.$refs.confirm.show({
                                title: "ログインエラー",
                                message: "ログインに失敗しました。<br/>" + error,
                                width: 500,
                                buttonYes: "OK",
                                buttonNo: "",
                                listenerYes: function () {
                                    fb.auth().signOut().then(function (){
                                        self.$store.commit("userUID", "")
                                        self.$store.commit("userData", null)
                                        self.$store.commit("loginState", 2)
                                    })
                                    return true
                                },
                            })
                        }
                    }
                )
            },
            login: function () {

                console.log("login")
                this.mode = null
            //     return

            //     // console.log("Home", "login", "start")
            //     const self = this

            //     var loggedInListener = function (user) {
            //         // console.log(user)

            //         window.addEventListener("popstate", function (e) {
                    
            //             if (self.mode != "title") {
            //                 self.$store.commit("requestBackToHome", true)
            //                 history.pushState(null, null, null);
            //             }
            //             return;

            //         });

            //         history.pushState(null, null, null);

            //         self.$store.commit("firebaseUser", user)
            //         self.$store.commit("loginState", 1)
            //         self.$store.commit("userUID", user.uid)
            //         // self.$store.commit("refreshRegisteredFields")
            //         self.$store.commit("refreshUserData", 
            //             {
            //                 userUID: user.uid,
            //                 completed: function () {
            //                     var userData = self.$store.getters["userData"]
            //                     // console.log("Home", "login", "userData", userData, "firebase user", self.$store.getters["firebaseUser"])
            //                     if (userData == null || userData.userUID == undefined) {
            //                         // console.log("Home", "created", "user data not regist!")
            //                         self.$refs.confirm.show({
            //                             title: "ようこそ",
            //                             message: "圃場管理システムへようこそ。<br/>まずは、初期設定を行いましょう。",
            //                             width: 500,
            //                             buttonYes: "開始",
            //                             buttonNo: "",
            //                             listenerYes: function () {
            //                                 self.$refs.initialSetting.show(user.uid)
            //                                 // self.onClickTitleMenuButton("setting")
            //                                 return true
            //                             },
            //                         })
            //                         self.mode = null
            //                     } else {
            //                         // console.log("Home", "created", "user data refresh!", self.$store.getters["userData"])
            //                         self.mode = "title"
            //                     }
            //                 },
            //                 failed: function (error) {
            //                     // console.log(error)
            //                     self.$refs.confirm.show({
            //                         title: "ログインエラー",
            //                         message: "ログインに失敗しました。<br/>" + error,
            //                         width: 500,
            //                         buttonYes: "OK",
            //                         buttonNo: "",
            //                         listenerYes: function () {
            //                             fb.auth().signOut().then(function (){
            //                                 self.$store.commit("userUID", "")
            //                                 self.$store.commit("userData", null)
            //                                 self.$store.commit("loginState", 2)
            //                             })
            //                             return true
            //                         },
            //                     })
            //                 }
            //             }
            //         )
            //     }

            //     const user = fb.auth().currentUser

            //     if (user != null) {
            //         // console.log("Home", "created", "user login completed(1)", user)
            //         loggedInListener(user)
            //     } else {
            //         fb.auth().onAuthStateChanged(user => {
            //             if (user) {
            //                 // console.log("Home", "created", "user login completed(2)", user)
            //                 loggedInListener(user)
            //             } else {
            //                 // console.log("Home", "created", "go login page", user)
            //                 self.$router.push("Login")
            //             }
            //         })
            //     }
            }
        }
    }
</script>
